import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

interface HourlyChartProps {
  hourly: { dt: number; temp: number; pop: number }[];
}

export function HourlyChart({ hourly }: HourlyChartProps) {
  const data = hourly.slice(0, 24).map((h) => ({
    time: new Date(h.dt * 1000).toLocaleTimeString([], { hour: "numeric" }),
    temp: Math.round(h.temp),
    rain: Math.round(h.pop * 100),
  }));

  return (
    <div className="rounded-2xl border border-border bg-card p-4">
      <h3 className="mb-3 text-sm font-semibold">Next 24 Hours</h3>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 5, right: 5, bottom: 0, left: -20 }}>
            <defs>
              <linearGradient id="tempGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="oklch(0.75 0.15 195)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="oklch(0.75 0.15 195)" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="time" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} />
            <YAxis tick={{ fontSize: 11 }} tickLine={false} axisLine={false} unit="°" />
            <Tooltip
              contentStyle={{
                borderRadius: 8,
                fontSize: 12,
                border: "1px solid var(--border)",
                background: "var(--popover)",
                color: "var(--popover-foreground)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
              }}
              labelStyle={{ color: "var(--foreground)", fontWeight: 600 }}
              itemStyle={{ color: "var(--popover-foreground)" }}
              cursor={{ stroke: "var(--border)", strokeWidth: 1 }}
            />
            <Area
              type="monotone"
              dataKey="temp"
              stroke="oklch(0.75 0.15 195)"
              strokeWidth={2}
              fill="url(#tempGrad)"
              name="Temp"
              unit="°"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
